import { Button, Flex, Text, useMantineTheme } from "@mantine/core";
import ActionCard from "src/components/ActionCard";
import ImageUpload from "src/components/ImageUpload";
import { CardRadius, HeightCard } from "src/utils/constants";
import { MdFileDownload } from "react-icons/md";
import { MIME_TYPES } from "@mantine/dropzone";
import { memo } from "react";
import { IJsonArr, parseCsvToJson } from "src/utils/utils";

type IImportProps = {
  title: string;
  onDownload: () => void;
  onUpload: (jsonArr: IJsonArr) => void;
  loading: boolean;
  uploadloading: boolean;
  disabled?: boolean;
  bannerContent?: string;
};

function ImportComponent({
  title,
  onDownload,
  loading,
  onUpload,
  uploadloading,
  disabled,
  bannerContent,
}: IImportProps) {
  const theme = useMantineTheme();
  const color = theme.colors.secondaryTextColor[4];

  const handleFileUpload = (base64String: string) => {
    const jsonArr = parseCsvToJson(base64String);
    onUpload(jsonArr);
  };

  return (
    <ActionCard
      title={""}
      titleContent={
        <Flex w={"100%"} align={"center"} justify={"center"} pt={5}>
          <Text size={17} fw={500}>
            {title}
          </Text>
        </Flex>
      }
      height={HeightCard.sm}
      radius={CardRadius.sm}
      size="md"
      bannerContent={bannerContent || ""}
    >
      <Flex direction={"column"} align={"center"}>
        {uploadloading ? (
          <Text fw={600} color={color}>
            Csv Uploading...
          </Text>
        ) : (
          <Text color={color}>Select a file to upload</Text>
        )}

        <ImageUpload
          loading={uploadloading}
          disabled={uploadloading || disabled}
          accept={[MIME_TYPES.csv]}
          my={7}
          onReadSuccess={handleFileUpload}
          src={""}
          alt={`${title} image`}
          sx={{
            maxHeight: 175,
            maxWidth: 175,
            margin: "auto",
          }}
        />
        <Button
          loading={loading}
          onClick={onDownload}
          sx={{
            backgroundColor: theme.colors.secondary[6],
            "&:hover": {
              background: theme.colors.secondary[5],
            },
          }}
          leftIcon={<MdFileDownload size={20} />}
          variant="subtle"
        >
          Download CSV template
        </Button>
      </Flex>
    </ActionCard>
  );
}

export default memo(ImportComponent);
